<template>
  <div id="breadcrumb">
    <div
      class="breadcrumb-wrapper"
      v-for="(item, index) in breadcrumbs"
      :key="index"
    >
      <div
        class="breadcrumb-item"
        :class="{ active: item.active }"
        :style="{ curor: item.url ? 'pointer' : 'default' }"
        v-if="item.title.toLowerCase() !== 'home'"
        @click="itemClicked(item)"
      >
        {{ $t(item.title) }}
      </div>
      <div
        class="breadcrumb-item"
        :class="{ active: item.active }"
        :style="{ cursor: item.url ? 'pointer' : 'default' }"
        v-if="item.title.toLowerCase() === 'home'"
        @click="itemClicked(item)"
      >
        <img src="/static/icons/home.svg" />
      </div>
      <div class="breadcrumb-divider" v-if="index !== breadcrumbs.length - 1">
        <img src="/static/icons/breadcrumb-divider.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  data() {
    return {
      breadcrumbs: undefined
    };
  },
  created() {
    this.breadcrumbs = this.$route.meta.breadcrumb;
  },
  methods: {
    itemClicked(item) {
      if (item.url) {
        this.$router.push(item.url);
      }
    }
  },
  watch: {
    "$route.meta.breadcrumb"() {
      this.breadcrumbs = this.$route.meta.breadcrumb;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#breadcrumb {
  display: flex;
  flex-wrap: wrap;
  .breadcrumb-wrapper {
    display: flex;
    .breadcrumb-item {
      font-size: 13px;
      align-items: center;
      &.active {
        font-weight: bold;
        color: $color-primary;
      }
      img {
        width: 20px;
      }
    }
    .breadcrumb-divider {
      margin-right: 10px;
      margin-left: 10px;
      img {
        width: 10px;
      }
    }
  }
}
</style>
